import React from 'react';
import { Wrapper } from './styles';
import PropTypes from 'prop-types'

const Header = ({children, bgColor, className, style}) => {
  return (
    <Wrapper bgColor={bgColor} className={className} style={style}>
      {children}
    </Wrapper>
  )
}

Header.propTypes = {
  children: PropTypes.node,
  bgColor: PropTypes.string,
}

export default Header;